import { useManageSubscriptionMeta } from '../../api/subscription-management/useManageSubscriptionMeta';
import { useManageSubscriptionData } from '../../api/subscription-management/useMagazinSubscriptionData';
import { useRenewals } from '../../api/subscription-management/renewals/useRenewals';
import { ProductEntry, RenewalLineOut } from '../../store/api';
import { mapSimpleRenewalBody } from './mappings/mapSimpleRenewalBody';
import { mapExtendedRenewalBody } from './mappings/mapExtendedRenewalBody';
import { UpdateLineItemsParams } from '../../api/subscription-management/renewals/updateRenewalLine';
import { mapHeader } from '../../shared/subscription-management/mappings/mapHeader';
import { useTranslation } from 'react-i18next';

export const useManageRenewalsData = ({
    page,
    pageSize,
    updateRenewalsState,
    spocCurrency,
    updateRenewalLine
}: {
    page: number;
    pageSize: number;
    updateRenewalsState: 'loading' | 'success' | 'error';
    spocCurrency: string;
    updateRenewalLine: (params: UpdateLineItemsParams) => void;
}) => {
    const { t } = useTranslation();
    const { data: meta, isLoading: isManageSubscriptionMetaLoading } = useManageSubscriptionMeta({
        enabled: updateRenewalsState === 'success'
    });
    const { data: renewals, isLoading: isLoadingRenewalLines } = useRenewals({
        enabled: updateRenewalsState === 'success'
    });
    const { data, isLoading: isLoadingSubscriptions } = useManageSubscriptionData(
        { page, pageSize, includeExpiredSubscriptions: false },
        {
            enabled: updateRenewalsState === 'success'
        }
    );

    const entries = combineSubscriptionsWithRenewalLines(data?.hits ?? [], renewals?.renewalLines ?? []);

    return {
        tableHeader: meta ? mapHeader(meta, t) : undefined,
        tableBody:
            meta && data
                ? meta.includesSharedCopies
                    ? mapExtendedRenewalBody(entries, updateRenewalLine, spocCurrency, t)
                    : mapSimpleRenewalBody(entries, spocCurrency, updateRenewalLine, t)
                : undefined,
        renewalLine: data?.totalHits ?? 0,
        isLoading: isLoadingSubscriptions || isManageSubscriptionMetaLoading || isLoadingRenewalLines,
        updateRenewalLine: updateRenewalLine
    };
};

const combineSubscriptionsWithRenewalLines = (entries: ProductEntry[], renewalLines: RenewalLineOut[]) => {
    return entries.map(subscription => {
        const renewal = renewalLines.find(line => line.productId === subscription.product.id);
        return {
            ...subscription,
            renewal
        };
    });
};
